export default "__VITE_ASSET__CkwgPIPn__"